var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.93a1.07 1.07 0 0 0 .53-.14l3.69-2.13a1.07 1.07 0 0 0 .53-.92V9.47h-2.12v3.65L18 14.64l-3.16-1.83-1.07 1.85 3.7 2.13a1.07 1.07 0 0 0 .53.14z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.31 19.21-6.86-4V7.33a1.07 1.07 0 0 0-.53-.92l-7.39-4.27a1.07 1.07 0 0 0-1.07 0l-7.38 4.27a1.07 1.07 0 0 0-.53.92v7.92l-6.86 4a1.07 1.07 0 0 0-.53.92v8.53a1.07 1.07 0 0 0 .53.92l7.39 4.27a1.08 1.08 0 0 0 1.07 0l6.86-4 6.86 4a1.08 1.08 0 0 0 1.07 0l7.39-4.27a1.07 1.07 0 0 0 .53-.92v-8.57a1.07 1.07 0 0 0-.55-.92zM18 4.3l6.32 3.65v7.3L18 18.9l-6.32-3.65v-7.3zm-7.39 27.4-6.32-3.65v-7.3l6.32-3.65 6.32 3.65v7.3zm21.1-3.65-6.32 3.65-6.32-3.65v-7.3l6.32-3.65 6.32 3.65z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.39 27.44-2.63-1.52v-3.65h-2.13v4.27a1.07 1.07 0 0 0 .53.92l3.69 2.13a1.08 1.08 0 0 0 1.07 0l3.69-2.13-1.07-1.85zM14.84 21.34l-3.69-2.13a1.07 1.07 0 0 0-1.07 0l-3.7 2.13 1.07 1.85 3.16-1.83 2.63 1.52v3.65h2.13v-4.26a1.07 1.07 0 0 0-.53-.93z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementIcon);
export default __webpack_public_path__ + "static/media/element-icon.3c557a6b6a413db87bb07bbd127ae420.svg";
export { ForwardRef as ReactComponent };